import React from 'react';
import { ArrowUpIcon, ArrowDownIcon, MinusIcon } from 'lucide-react';
interface MetricCardProps {
  title: string;
  value: string;
  subValue?: string;
  trend?: 'up' | 'down' | 'neutral';
  trendValue?: string;
  status?: 'success' | 'warning' | 'danger' | 'neutral';
  progress?: number; // 0 to 100
}
export function MetricCard({
  title,
  value,
  subValue,
  trend,
  trendValue,
  status = 'neutral',
  progress
}: MetricCardProps) {
  const getStatusColor = () => {
    switch (status) {
      case 'success':
        return 'text-emerald-400';
      case 'warning':
        return 'text-amber-400';
      case 'danger':
        return 'text-rose-400';
      default:
        return 'text-slate-400';
    }
  };
  const getTrendIcon = () => {
    switch (trend) {
      case 'up':
        return <ArrowUpIcon className="w-4 h-4 mr-1" data-id="element-51" />;
      case 'down':
        return <ArrowDownIcon className="w-4 h-4 mr-1" data-id="element-52" />;
      default:
        return <MinusIcon className="w-4 h-4 mr-1" data-id="element-53" />;
    }
  };
  return <div className="bg-slate-800 border border-slate-700 rounded-lg p-5 shadow-sm hover:border-slate-600 transition-colors" data-id="element-54">
      <div className="flex justify-between items-start mb-2" data-id="element-55">
        <h3 className="text-slate-400 text-sm font-medium uppercase tracking-wider" data-id="element-56">
          {title}
        </h3>
        {trend && <div className={`flex items-center text-xs font-medium ${getStatusColor()}`} data-id="element-57">
            {getTrendIcon()}
            {trendValue}
          </div>}
      </div>

      <div className="flex items-baseline gap-2 mb-1" data-id="element-58">
        <span className="text-2xl font-bold text-white" data-id="element-59">{value}</span>
      </div>

      {subValue && <p className="text-xs text-slate-500 mb-3" data-id="element-60">{subValue}</p>}

      {progress !== undefined && <div className="w-full bg-slate-700 rounded-full h-1.5 mt-2" data-id="element-61">
          <div className={`h-1.5 rounded-full ${status === 'success' ? 'bg-emerald-500' : status === 'warning' ? 'bg-amber-500' : status === 'danger' ? 'bg-rose-500' : 'bg-blue-500'}`} style={{
        width: `${Math.min(Math.max(progress, 0), 100)}%`
      }} data-id="element-62" />
        </div>}
    </div>;
}